var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('j-base-select',{attrs:{"id":_vm.id,"options":_vm.options,"value":_vm.value,"status":_vm.status,"size":_vm.size,"allowSelectNothing":false},on:{"input":function($event){return _vm.onInput($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }